/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { ValidationErrorLocItem } from './validationErrorLocItem';

export interface ValidationError {
  loc: ValidationErrorLocItem[];
  msg: string;
  type: string;
}
